// extracted by mini-css-extract-plugin
export default {"center":"ScreamsList_center__k10cK","middle":"ScreamsList_middle__xaDRy","no_screams":"ScreamsList_no_screams__F3gIG","validate":"ScreamsList_validate__hiYDl"};